export interface EssayTheme {
  id?: number;
  title?: string;
  description?: string;
  supportTexts?: EssaySupportText[];
}

export interface EssaySupportText {
  id: number;
  title: string;
  text: string;
  position: number;
}

export interface Document {
  name?: string;
  dataUrl?: string;
}
export interface EvaluationEssay {
  id?: number;
  document?: Document;
  title?: string;
  text?: string;
  grade?: number;
  hasAcceptedToS?: boolean;
}
export interface EssayState {
  essayTheme?: EssayTheme;
  availableEssayThemes?: EssayTheme[];
  essay?: EvaluationEssay;
}

const essay: EssayState = {
  essayTheme: undefined,
  availableEssayThemes: [],
  essay: undefined,
};

export default essay;
